<template>
  <div class="flex flex-col">
    <div>
      {{ $t("SupportPage.ContactUs.weAreHereToSupportYou") }}
    </div>
    <div class="flex items-center mt-4">
      <svg-icon name="e-ifu" class="me-4 icon-2xl" />
      <div class="whitespace-pre-line flex-shrink-0">
        <a :href="instructionsForUseUrl" target="_blank">
          {{ $t("Legal.instructionsForUse") }}
        </a>
      </div>
    </div>
    <div class="mt-4">
      {{ $t("SupportPage.ContactUs.emailUs") }}
      <a
        class="block contact-us_email"
        :href="`mailto:${email}`"
        target="_blank"
        @click="onEmailClick"
      >
        {{ email }}
      </a>
    </div>
    <div class="mt-2">
      {{ $t("SupportPage.ContactUs.orVisitWebsite") }}
      <a
        class="block contact-us_website"
        :href="`https://${website}`"
        target="_blank"
        @click="onWebsiteClick"
      >
        {{ website }}
      </a>
    </div>
    <div class="flex mt-4">
      <svg-icon
        name="manufacturer"
        class="me-6 icon-7xl contact-us_manufacturer-logo"
      />
      <div class="whitespace-pre-line contact-us_manufacturer">
        {{ $t("Legal.address") }}
      </div>
    </div>
    <div class="flex mt-4">
      <svg-icon
        name="european-representative"
        class="me-6 icon-7xl contact-us_european-representative-logo"
      />
      <p class="whitespace-pre-line contact-us_european-representative">
        {{ $t("Legal.europeanRepresentativeAddress") }}
      </p>
    </div>
  </div>
</template>

<script>
import { trackEvent } from "@/plugins/vueApplicationInsights";

export default {
  data() {
    return {
      email: "customersupport@mindmaze.com",
      website: "mindmaze.com/contact",
      instructionsForUseUrl: "https://mindmaze.com/user-manuals/",
    };
  },
  methods: {
    onEmailClick() {
      trackEvent(`ContactDetails.UI.EmailUs`);
    },
    onWebsiteClick() {
      trackEvent(`ContactDetails.UI.Website`);
    },
  },
};
</script>
